import { render, staticRenderFns } from "./QuoteVentilationRoomCard.vue?vue&type=template&id=b5283020&"
import script from "./QuoteVentilationRoomCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteVentilationRoomCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports